import HeroContent from "./HeroContent";
import HeroVisual from "./HeroVisual";

export default function HeroSection() {
  return (
    <section className="relative overflow-hidden pt-8 pb-16 sm:pt-12 sm:pb-20 lg:!pt-16 lg:!pb-24">
      {/* آندرلیگنت‌های پس‌زمینه */}
      <div aria-hidden className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute -top-24 end-[-10%] h-[380px] w-[380px] rounded-full bg-teal-2/20 blur-[100px] dark:bg-teal-2/10" />
        <div className="absolute -bottom-32 start-[-10%] h-[320px] w-[320px] rounded-full bg-gold-2/20 blur-[100px] dark:bg-gold-2/10" />
      </div>

      <div className="mx-auto max-w-container px-5 sm:px-7">
        <div className="grid grid-cols-1 items-center gap-14 lg:!grid-cols-[1.1fr_0.9fr] lg:!gap-10 xl:gap-16">
          <HeroContent />
          <HeroVisual />
        </div>
      </div>
    </section>
  );
}